import { Input, InputProps } from 'antd';
import { FC } from 'react';

export interface AddressInputComponentProps {
  value?: string;
  onChange?: InputProps['onChange'];
}

export const AddressInputComponent: FC<AddressInputComponentProps> = ({
  value,
  onChange,
}) => (
  <Input
    value={value}
    onChange={onChange}
  />
);
